import { Component, OnInit } from '@angular/core';
import { map, switchMap, take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketplaceAppService } from '../../core/marketplace-app/marketplace-app.service';
import { MarketplaceApp } from '@vendasta/marketplace-apps/v1';

@Component({
  template: ``,
})
export class AccountsRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private marketplaceAppService: MarketplaceAppService,
  ) {}

  ngOnInit(): void {
    const appId$ = this.route.params.pipe(map((params) => params.appId));

    appId$
      .pipe(
        take(1),
        switchMap((appId) => this.marketplaceAppService.getPublished(appId)),
      )
      .subscribe((app) => {
        this.router.navigate(['accounts'], { queryParams: this.buildQueryParams(app) });
      });
  }

  buildQueryParams(app: MarketplaceApp): object {
    const queryParams = {};
    queryParams['accounts-table'] = `{"product":[{"id":"${app.appId}", "name":"${app.name}"}]}`;
    return queryParams;
  }
}
